import { IIdKeyEntityBase } from '../../types/models/base/IIdKeyEntityBase';
import { ReadDataService } from './ReadDataService';

export abstract class UpdateDataService<TModel extends IIdKeyEntityBase<TKey>, TQuery, TKey> extends ReadDataService<TModel, TQuery, TKey> 
{	
	save(data: TModel[]) {
		return this.api.post<TModel[]>(`${this.prefixUrl}/save`, data);
	}

	delete(ids: number[]){
		return this.api.post(`${this.prefixUrl}/Delete`, ids);
	}
}